import React from "react";
import {toPersianNumbers} from "../../utils/toPersianNumbers";
import Button from "../Button";
import ImageGalleryEdit from "./ImageGalleryEdit";

const ProductPreview = ({ productData, categoryAttributes }) => {
  if (!productData) return <div className="text-center py-12">در حال بارگذاری...</div>;

  // داده‌های ثابت تا زمانی که از بک بیاوریم
  const staticData = {
    rating: 4.2,
    supplier: "سنگبری آذرخش",
    reviewsCount: 128,
    warranty: "18 ماه گارانتی",
    brand: "برند نمونه",
    sku: "PRD-2024-001",
    deliveryTime: "ارسال 24 ساعته",
  };
  const categoryName = productData.category
  ? typeof productData.category === "object"
      ? productData.category.name || productData.category.value
      : productData.category
    : "ثبت نشده";
  // رندر امن مقدارها
  const renderValue = (value) => {
    if (value === null || value === undefined) return "ثبت نشده";
    if (typeof value === "object") {
      if (value.value !== undefined) return value.value;
      if (value.name !== undefined) return value.name;
      if (value.title !== undefined) return value.title;
      return JSON.stringify(value);
    }
    return value;
  };

  // آدرس تصویر (string / File / {url})
  const getImageUrl = (img) => {
    if (!img) return "";
    if (typeof img === "string") return img;
    if (typeof File !== "undefined" && img instanceof File) {
      return URL.createObjectURL(img);
    }
    if (typeof Blob !== "undefined" && img instanceof Blob) {
      return URL.createObjectURL(img);
    }
    if (typeof img === "object" && img.url) return img.url;
    return "";
  };

  // ساخت لیست یکپارچه ویژگی‌ها از attributes + custom_attributes
  const buildAttributesList = () => {
    const list = [];

    // ویژگی‌های دسته‌ای
    if (productData.attributes && Array.isArray(categoryAttributes)) {
      categoryAttributes.forEach((item) => {
        const attr = item.attribute;
        const stored = productData.attributes[attr.id];

        if (stored) {
          list.push({
            label: attr.name || attr.title,
            value: renderValue(stored.value),
            unit: attr.unit,
            is_featured: stored.is_featured,
          });
        }
      });
    }

    // ویژگی‌های سفارشی
    if (Array.isArray(productData.custom_attributes)) {
      productData.custom_attributes.forEach((attr, idx) => {
        list.push({
          label: attr.title || `ویژگی ${idx + 1}`,
          value: `${renderValue(attr.value)}${attr.unit ? " " + attr.unit : ""}`,
          is_featured: attr.is_featured,
        });
      });
    }

    return list;
  };

  const allAttributes = buildAttributesList();
  const topAttributes = allAttributes.filter(attr => attr.is_featured);
  const hasAnyAttribute = allAttributes.length > 0;

  const isProductComplete = productData.name && productData.category && productData.price;

  // مپ کردن واحد
  const unitLabel =
    productData.unit_of_measure === "count"
      ? "عدد"
      : productData.unit_of_measure === "package"
      ? "بسته":
      productData.unit_of_measure === "weight"
      ? "کیلو گرم"
      : productData.unit_of_measure === "length"
      ? "متر"
      : productData.unit_of_measure === "area"
      ? "متر مربع"
      : productData.unit_of_measure === "litr"
      ? "لیتر"
      : productData.unit_of_measure === "volume"
      ? "متر مکعب"
      : "ثبت نشده";

  const mainImageUrl = productData.images?.[0] ? getImageUrl(productData.images[0]) : "";

  return (
    <div className="max-w-full mx-auto bg-white rounded-2xl shadow-lg p-6">
      <div className="flex flex-col lg:flex-row gap-8">
        <main className="w-full lg:w-3/4">

          {/* ستون تصویر (راست در فیگما) */}
          <div className="grid lg:grid-cols-2 gap-6 items-start mb-6">
              <ImageGalleryEdit
                images={productData.images}
                productName={productData.name}
              />
            {/* عنوان و اطلاعات بالای صفحه */}
            <div className="order-2 lg:order-2 mb-6 text-center lg:text-right">
              <h1 className="text-[20px] text-[#1E3A5F] font-semibold">
                {productData.name || "نام محصول ثبت نشده"}
              </h1>
              <div className="mt-1 text-sm text-gray-600">
                {productData.brand} / {categoryName}
              </div>
              <div className="mt-1 text-xs text-gray-500">
                {staticData.supplier} • امتیاز {toPersianNumbers(staticData.rating)} از {toPersianNumbers(staticData.reviewsCount)} نظر
              </div>
              <h2 className="mt-[24px] text-base font-bold text-gray-900 mb-3">ویژگی‌ها</h2>
              {topAttributes.length > 0 ? (
                <ul className="space-y-1 text-sm text-gray-800">
                  {topAttributes.map((attr, idx) => (
                      <li key={idx}>
                        {attr.label} : <span className="font-medium">{toPersianNumbers(attr.value)}</span>
                          <span className="font-medium">  {toPersianNumbers(attr.unit)}</span>
                      </li>
                  ))}
                </ul>
              ) : (
                  <p className="text-sm text-gray-400">هیچ ویژگی‌ای ثبت نشده است.</p>
              )}
            </div>
          </div>

            <section className="mb-8">
              <h2 className="text-base font-bold text-gray-900 mb-3">توضیحات</h2>
              <div
                  className="bg-gray-50 rounded-xl border border-gray-200 px-4 py-5 text-sm leading-relaxed text-gray-700">
                {productData.description ? (
                    productData.description.split("\n").map((line, index) => (
                        <p key={index} className={line ? "mb-2" : "mb-4"}>
                          {line || <br/>}
                        </p>
                    ))
                ) : (
                    <p className="text-gray-400">هیچ توضیحی ثبت نشده است.</p>
                )}
              </div>
            </section>

            {/* بلوک ویژگی‌ها در پایین سمت راست (مثل بخش "ویژگی‌ها" در انتهای فیگما) */}
            {hasAnyAttribute && (
                <section className="mt-4">
                  <h2 className="mt-[24px] text-base font-bold text-gray-900 mb-3">ویژگی‌ها</h2>
                  <div className="space-y-1 text-sm text-gray-800">
                    {allAttributes.map((attr, idx) => (
                        <div key={idx}>
                          {attr.label} : <span className="font-medium">{toPersianNumbers(attr.value)}</span>
                          <span className="font-medium">  {toPersianNumbers(attr.unit)}</span>
                        </div>
                    ))}
                  </div>
                  <div className="space-y-1 text-sm text-gray-800">
                    <div>وزن (کیلوگرم) : <span className="font-medium">{toPersianNumbers(productData.weight)}</span>
                    </div>
                    <div>عرض (سانتی متر) : <span className="font-medium">{toPersianNumbers(productData.width)}</span>
                    </div>
                    <div>طول (سانتی متر) : <span className="font-medium">{toPersianNumbers(productData.length)}</span>
                    </div>
                    <div>ارتفاع (سانتی متر) : <span
                        className="font-medium">{toPersianNumbers(productData.height)}</span></div>
                  </div>
                </section>
            )}
        </main>
        {/*ستون سمت چپ*/}
        <aside className="w-full lg:w-1/4 space-y-8">
          <div>
            <h3 className="text-base mb-2 text-[#1E3A5F] font-semibold">
              {staticData.supplier || "نام تأمین کننده"}
            </h3>
            <div className="my-2 text-xs text-gray-500">
              امتیاز {toPersianNumbers(staticData.rating)} از {toPersianNumbers(staticData.reviewsCount)} نظر
            </div>
            <div className="bg-gray-50 rounded-xl border border-gray-200 p-4 space-y-4">
            <div>
                <div className="text-[18px] text-[#1E3A5F] font-semibold">
                  {toPersianNumbers(productData.price)
                      ? `${Number(productData.price).toLocaleString("fa-IR")} تومان`
                      : "قیمت ثبت نشده"}
                </div>
                {productData.price && (
                    <div className="text-xs text-gray-400 mt-1">
                      واحد: {unitLabel}
                    </div>
                )}
              </div>
              <Button
                  variant={'primary'}
                  children={'افزودن به سبد خرید'}/>
            </div>
          </div>
          <div>
            <h3 className="mb-4 text-[18px] text-[#1E3A5F] font-semibold">روش‌های ارسال</h3>
            <ul className="space-y-1 text-sm text-gray-800">
              {productData.delivery_by_supplier && (
                  <li>ارسال توسط تأمین کننده</li>
              )}
              {productData.delivery_by_customer && (
                  <li>تحویل توسط مشتری</li>
              )}
              {productData.delivery_by_carrier && (
                  <li>ارسال توسط شرکت حمل</li>
              )}
              {!productData.delivery_by_supplier &&
                  !productData.delivery_by_customer &&
                  !productData.delivery_by_carrier && (
                      <li className="text-gray-400">روش ارسال ثبت نشده است</li>
                  )}
            </ul>
          </div>

          {/* خلاصه وضعیت محصول (برای پیش‌نمایش ادمین) */}
          <div className="bg-gray-50 rounded-xl border border-gray-200 p-4 space-y-3 text-sm">
            <div className="flex justify-between items-center">
              <span className="text-gray-600">وضعیت کالا</span>
              <span
                className={`px-3 py-1 rounded-full text-xs font-medium ${
                  isProductComplete
                    ? "bg-green-100 text-green-800"
                    : "bg-yellow-100 text-yellow-800"
                }`}
              >
                {isProductComplete ? "تقریباً کامل" : "ناقص"}
              </span>
            </div>
            <div className="flex justify-between items-center">
              <span className="text-gray-600">تعداد عکس‌ها</span>
              <span className="font-medium text-gray-900">
               {toPersianNumbers(6)}/ {toPersianNumbers(productData.images?.length || 0)}
              </span>
            </div>
            <div className="flex justify-between items-center">
              <span className="text-gray-600">تعداد ویژگی‌ها</span>
              <span className="font-medium text-gray-900">
                {toPersianNumbers(allAttributes.length)}
              </span>
            </div>
          </div>
          {/* کارت زمان تحویل ثابت (مطابق طراحی) */}
          <div className="bg-white rounded-xl border border-gray-200 p-4 space-y-3">
            <h3 className="text-sm font-bold text-gray-900 mb-2">زمان تحویل</h3>
            <div className="flex items-center gap-3">
              <div className="bg-blue-50 p-3 rounded-xl">
                <svg
                  className="w-6 h-6 text-blue-600"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
                  />
                </svg>
              </div>
              <div>
                <div className="font-semibold text-gray-900">
                  {toPersianNumbers(staticData.deliveryTime)}
                </div>
                <div className="text-xs text-gray-600">در شهرهای اصلی</div>
              </div>
            </div>
          </div>
        </aside>
      </div>
    </div>
  )
      ;
};

export default ProductPreview;
